/**
 * Small uppercase label that opens a section ("THE PRODUCTS", "WHY TEAMS SWITCH").
 * Keep the text short, two or three words.
 */
export default function Eyebrow({ children, tone = 'light', className = '' }) {
  const color = tone === 'dark' ? 'text-brand-400' : 'text-brand-700';
  return (
    <p data-component-id="src/components/ui/Eyebrow.jsx:8:4" data-component-path="src/components/ui/Eyebrow.jsx" data-component-line="8" data-component-end-line="10" data-component-file="Eyebrow.jsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%7D" className={`text-[11px] font-semibold uppercase tracking-[0.16em] ${color} ${className}`}>
      {children}
    </p>
  );
}
